<template>
  <div>
    <search-toolbar resultType='staffs' :from="from" :to="to" :sortFields="sortFields" :totalCount="totalCount" @search="getStaffs($event)"
      @clearsearch="clearSearch($event)" @changeSort="changeSort($event)" />
    <div class="md-layout" id='stafflist'>
      <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(staff, index) in staffs"
        :key="index" :class="staffEnable(staff) ? 'staff-enable-opacity': ''" :title="staffEnable(staff) ? 'disabled staff': ''">
        <md-list class="md-double-line">
          <md-list-item>
            <md-avatar>
              <img class="staff-image" v-bind:src="displayPicture(staff)" :alt=staff.name @error="onError">
            </md-avatar>
            <div class="md-list-item-text">
              <span v-text="setDisplayName(staff)"></span>
              <span v-if="staff.email" v-text="staff.email"></span>
              <span v-text="displayStaffRoles(staff)"></span>
            </div>
            <md-avatar>
              <img src="../../../assets/img/integration_icon.png" v-if="staffIsServiceAccount(staff)" alt="integration user" title="integration user" />
            </md-avatar>
            <md-button class="md-raised md-primary" :disabled="sending" v-can-edit v-if="hasCertainRoleId(staff,'db861299-e18d-4d29-be64-02d675c98a25')"
              @click="removeStaff(staff)">Remove</md-button>
          </md-list-item>
        </md-list>
      </div>
    </div>
    <div class="md-layout-item md-small-size-100 right-align" v-can-edit>
      <md-button class="md-raised md-primary" :disabled="sending" @click="inviteTechnogymStaff()">Invite technogym
        staff</md-button>
    </div>
    <dialog-custom :parentref='parentref' :showDialog="showDialog" @hidedialog="hidedialog"></dialog-custom>
  </div>
</template>

<script>
import SearchToolbar from '@/components/elements/search-toolbar'
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import Utils from '@/utils/utils'
import { infiniteScroll } from '@/utils/infinite-scroll'
import DefaultUserPhotoMaleThumb from '@/assets/img/DefaultUserPhotoMaleThumb.png'
import DefaultUserPhotoFemaleThumb from '@/assets/img/DefaultUserPhotoFemaleThumb.png'
import DialogCustom from '@/components/elements/add-technogym-staff'
import NotificationService from '@/services/notificationService'

export default {
  name: 'ChainStaff',
  data: () => ({
    searchInput: '',
    staffs: [],
    totalCount: null,
    sortOrder: 'asc',
    selectedSortField: 'FullName',
    sortFields: ['FullName'],
    from: 0,
    to: 60,
    sending: false,
    showDialog: false
  }),
  mixins: [infiniteScroll],
  props: ['parentref'],
  components: {
    NavigationLayout,
    SearchToolbar,
    DialogCustom
  },
  methods: {
    displayPicture (staff) {
      var pictureUrl = staff.thumbPictureUrl
      if (!pictureUrl) {
        if (staff.gender === 'M') {
          return DefaultUserPhotoMaleThumb
        } else {
          return DefaultUserPhotoFemaleThumb
        }
      }
      return pictureUrl
    },
    setDisplayName (staff) {
      var lastName = staff.lastName ? staff.lastName.trim() : ''
      var firstName = staff.firstName ? staff.firstName.trim() : ''
      if (!lastName || !firstName) {
        return staff.Email.trim()
      } else {
        return lastName + ' ' + firstName
      }
    },
    staffEnable (staff) {
      return !staff.enable
    },
    staffIsServiceAccount (staff) {
      return staff.isServiceAccount
    },
    displayStaffRoles (staff) {
      return staff.roles ? staff.roles.map(a => a.name).join(',') : ''
    },
    hasCertainRoleId (staff, id) {
      for (var i = 0; i < staff.roles.length; i++) {
        if (staff.roles[i].Id === id) {
          return true
        }
      }
      return false
    },
    changeSort (sort) {
      this.sortOrder = sort
      this.staffs = this.staffs.sort(this.sortOrder === 'asc' ? Utils.orderArrayObjectByFieldAlphabeticalAscInvariant(
        'displayFullName') : Utils.orderArrayObjectByFieldAlphabeticalDescInvariant('displayFullName'))
    },
    async getStaffs (searchBody) {
      this.searchInput = searchBody.textFilter
      searchBody['AccountStatus'] = 'all'
      await NotificationService.manageNotification(this.parentref, await RepositoryService.searchStaffs(searchBody),
        (data) => {
          var results = data.items.sort(searchBody.SortOrder === 'asc' ? Utils.orderArrayObjectByFieldAlphabeticalAscInvariant(
            'displayFullName') : Utils.orderArrayObjectByFieldAlphabeticalDescInvariant('displayFullName'))
          this.staffs = results
          this.totalCount = data.totalCount
        })
    },
    clearSearch () {
      this.from = 0
      this.to = 60
      this.searchInput = ''
      this.getStaffs({
        'from': this.from,
        'to': this.to,
        'SortOrder': this.sortOrder,
        'textFilter': this.searchInput,
        'SortField': this.selectedSortField
      })
    },
    async infiniteHandler () {
      if (!this.totalCount || this.to <= this.totalCount) {
        this.from = this.to + 1
        this.to += 60
        var searchBody = {
          'from': this.from,
          'to': this.to,
          'SortOrder': this.sortOrder,
          'textFilter': this.searchInput,
          'SortField': this.selectedSortField,
          'AccountStatus': 'all'
        }
        await NotificationService.manageNotification(this.parentref, await RepositoryService.searchStaffs(searchBody),
          (data) => {
            var results = data.items.sort(searchBody.SortOrder === 'asc' ? Utils.orderArrayObjectByFieldAlphabeticalAscInvariant(
              'name') : Utils.orderArrayObjectByFieldAlphabeticalDescInvariant('name'))
            for (var i = 0; i < results.length; i++) {
              this.staffs.push(results[i])
            }
            this.totalCount = data.totalCount
          })
      }
    },
    onError (e) {
      let defaultURL = 'https://cdnmedia.mywellness.com/facility_resources/images/defaultlogo.png'
      if (e.target.src !== defaultURL) {
        e.target.src = defaultURL
      }
    },
    async removeStaff (staff) {
      await NotificationService.manageNotification(this.parentref, await RepositoryService.deleteStaff(staff.id),
        (data) => { this.staffs = Utils.removeObjectFromArrayObject(this.staffs, 'id', staff.id) })
    },
    inviteTechnogymStaff () {
      this.showDialog = true
    },
    hidedialog () {
      this.showDialog = false
    }
  },
  mounted: async function () {
    // Initially load some items.
    this.getStaffs({
      'from': this.from,
      'to': this.to,
      'SortOrder': this.sortOrder,
      'textFilter': this.searchInput,
      'SortField': this.selectedSortField
    })
  }
}

</script>

<style lang="scss" scoped>
  .md-list {
    width: 320px;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    border: 1px solid rgba(#000, .12);
  }

  .staff-enable-opacity {
    opacity: 0.5;
  }

  .staff-logo {
    max-width: 80px;
    max-height: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }

</style>
